import { bookingsListTypes } from './actionTypes';

export const getBookingsList = (payload: any) => ({
    type: bookingsListTypes.GET_BOOKINGS_LIST,
    payload,
});

export const getBookingsListSuccess = (payload: any) => ({
    type: bookingsListTypes.GET_BOOKINGS_LIST_SUCCESS,
    payload,
});

export const getBookingsListFail = (error: any) => ({
    type: bookingsListTypes.GET_BOOKINGS_LIST_FAIL,
    payload: error,
});

export const getMilestoneConfigBK = () => ({
    type: bookingsListTypes.GET_MILESTONESCONFIG_BK,
});

export const getMilestoneConfigBKSuccess = (payload: any) => ({
    type: bookingsListTypes.GET_MILESTONESCONFIG_BK_SUCCESS,
    payload,
});

export const getMilestoneConfigBKFail = (payload: any) => ({
    type: bookingsListTypes.GET_MILESTONESCONFIG_BK_FAIL,
    payload,
});
